import { type FormEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useLogout } from '@/modules/auth/hooks/use-logout'
import { toAuthUserDisplay } from '@/modules/auth/utils/auth-user-display'
import { useAppStore } from '@/store/use-app-store'
import { useAuthStore } from '@/store/use-auth-store'

interface UseAppTopbarResult {
  query: string
  setQuery: (value: string) => void
  selectedCity: string
  loggedIn: boolean
  userName: string
  userInitials: string
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void
  handleNavigate: (path: string) => void
  handleLogout: () => void
}

export function useAppTopbar(): UseAppTopbarResult {
  const navigate = useNavigate()
  const status = useAuthStore((state) => state.status)
  const authUser = useAuthStore((state) => state.user)
  const user = toAuthUserDisplay(authUser)
  const selectedCity = useAppStore((state) => state.selectedCity)
  const setSearchQuery = useAppStore((state) => state.setSearchQuery)
  const logout = useLogout()
  const [query, setQuery] = useState('')

  function handleSubmit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault()

    const normalizedQuery = query.trim()
    setSearchQuery(normalizedQuery)

    const params = new URLSearchParams()
    if (normalizedQuery) {
      params.set('q', normalizedQuery)
    }

    navigate(`/buscar${params.toString() ? `?${params.toString()}` : ''}`)
  }

  function handleNavigate(path: string): void {
    navigate(path)
  }

  function handleLogout(): void {
    logout()
  }

  return {
    query,
    setQuery,
    selectedCity,
    loggedIn: status === 'authenticated',
    userName: user.name,
    userInitials: user.initials,
    handleSubmit,
    handleNavigate,
    handleLogout,
  }
}
